module.exports = __webpack_public_path__ + "img/news3.ee5a1842.png";